/**
 * Labels are zero-padded so Mixpanel's alphabetical breakdown ordering matches
 * chronological order — `'3-6s'` would sort after `'12s+'`.
 */
export type LatencyTier = '00-03s' | '03-06s' | '06-12s' | '12s+';

/**
 * Boundaries are tuned to the COI generate mutation, which lists documents,
 * calls generate, then polls up to five times with a 2s sleep each. The buckets
 * separate a first-poll hit, a second or third poll, a late poll, and the
 * timeout path.
 */
export const toLatencyTier = (elapsedMs: number): LatencyTier => {
  if (elapsedMs < 3_000) return '00-03s';
  if (elapsedMs < 6_000) return '03-06s';
  if (elapsedMs < 12_000) return '06-12s';
  return '12s+';
};
